import { api } from '../lib/api'
import type { DRFPage, PostCard } from '../types'

export type PostsPage = DRFPage<PostCard>

function isPage(data: any): data is PostsPage {
  return data && Array.isArray(data.results)
}

async function tryGet(url: string) {
  const { data } = await api.get(url)
  return data
}

/**
 * Fetch posts authored by a person (by profile public_id).
 */
export async function fetchPostsByPerson(publicId: string, cursor?: string | null): Promise<{ items: PostCard[]; next_cursor: string | null }> {
  if (!publicId) return { items: [], next_cursor: null }

  // If a cursor URL is provided, just follow it as-is.
  if (cursor) {
    const { data } = await api.get<PostsPage>(cursor)
    const results = Array.isArray((data as any)?.results) ? (data as any).results : []
    return { items: results, next_cursor: (data as any)?.next ?? null }
  }

  // Preferred: query param by author public id
  try {
    const { data } = await api.get<PostsPage>(`/api/posts/`, { params: { author_public_id: publicId } })
    const results = Array.isArray((data as any)?.results) ? (data as any).results : []
    return { items: results, next_cursor: (data as any)?.next ?? null }
  } catch (err: any) {
    if (![404, 405].includes(err?.response?.status)) {
      // eslint-disable-next-line no-throw-literal
      throw err
    }
  }

  // Fallback: generic key variants often seen
  try {
    const { data } = await api.get<PostsPage>(`/api/posts/`, { params: { profile_public_id: publicId } })
    const results = Array.isArray((data as any)?.results) ? (data as any).results : []
    return { items: results, next_cursor: (data as any)?.next ?? null }
  } catch {
    // Ultimately return empty safely
    return { items: [], next_cursor: null }
  }
}
